<!--
 * @Description: 
-->
<!--
 * @Description: 
-->
<template>
    <div>
      <!-- 顶部图片 -->
      <div class="top-pic">
        <img src="../../assets/contact/contact-banner.png" alt="">
      </div>
      <div class="content">
        <div class="content-center">
          <div class="title">联系我们</div>
          <div class="pic_item">
              <div class="pic_item_left">
                 <img src="../../assets/contact/24gf-telephone2.png" alt="">
                 <h3>010-53340557</h3>
                 <p>电话</p>
              </div>
              <div class="hr"></div>
              <div class="pic_item_left">
                <img src="../../assets/contact/mail.png" alt="">
                <h3>info@clcimplant</h3>
                <p>邮箱</p>
             </div>
          </div>
          <div class="pic_address">
             <img src="../../assets/contact/daohang.png" alt="">
             北京市海淀区高梁桥斜街59号中坤大厦905室
          </div>
          

          <div class="pic_content">
             <p>CLC西傲在全国范围内设有经销网点及专业的合作伙伴，如您有任何关于产品的问题及需求，
              可以发送邮件到我们的邮箱或拨打CLC客服电话010-53340557，我们会在第一时间为您提供专业便捷的服务。 </p>
          </div>
   
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {};
    }
  };
  </script>
  <style lang="scss" scoped>
  .top-pic {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
    margin-top: 2px;
  }
  .top-pic img {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
  }
  
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .content-center {
    width: 1000px;
  }
  
  .title {
    font-size: 20px;
    line-height: 60px;
    margin-top: 20px;
    margin-bottom: 30px;
    border-bottom: 1px solid #eeeeee;
  }
  .pic_item {
    width: 1000px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #eeeeee;
  }
  .pic_item_left {
    width: 50%;
    padding: 58px 74px;
    box-sizing: border-box;
  }
  .hr {
    width: 1px;
    height: 210px;
    background: #EEEEEE;
    margin-top: 40px;
  }
  .pic_item_left img {
    width: 30px;
    height: 28px;
  }
  .pic_item_left h3 {
    margin-top: 18px;
    font-size: 24px;
    color: #333;
    font-weight: 700;
  }
  .pic_item_left p {
    margin-top: 24px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .text {
    font-weight: bold;
    line-height: 26px;
    margin-top: 26px;
  }
  .pic_address {
    padding-left: 76px;
    padding-top: 49px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 48px;
  }
  .pic_address img {
    width: 26px;
    height: 32px;
    vertical-align: middle;
    margin-right: 10px;
  }
  .pic_content p {
    width: 775px;
    margin-top: 101px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 48px;
    margin-bottom: 182px;
  }
  </style>
  